/**
 * Mobile text rules for widget templates. A phone tile is about 165 px wide, so the desktop
 * "one line, ellipsis" rule would cut numbers ("446,…") and the data-carrying sub-lines.
 * On mobile numbers are never clipped (the font steps down instead) and labels wrap to two lines.
 */

/** Font size for a headline number: the longer the string, the smaller the type. */
export function valueFontSize(value, mobile, desktop = 28) {
  if (!mobile) return desktop;
  const length = String(value ?? '').length;
  if (length <= 7) return Math.min(desktop, 26);
  if (length <= 10) return Math.min(desktop, 22);
  return Math.min(desktop, 19);
}

/** sx for a headline number. Desktop: one line with ellipsis. Mobile: one line, never clipped. */
export function valueSx(mobile) {
  return mobile
    ? { whiteSpace: 'nowrap', overflow: 'visible', textOverflow: 'clip' }
    : { whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' };
}

/** sx for a label or sub-line. Desktop: one line with ellipsis. Mobile: up to `lines` lines. */
export function labelSx(mobile, lines = 2) {
  return mobile
    ? { display: '-webkit-box', WebkitLineClamp: lines, WebkitBoxOrient: 'vertical', overflow: 'hidden', whiteSpace: 'normal', overflowWrap: 'anywhere' }
    : { whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' };
}
